import { defineComponent as _defineComponent } from 'vue'
import {useRouter} from 'vue-router';
import {computed} from 'vue';
import database from './components/database.vue';
import newUser from './components/new-user.vue';
import databaseUpdate from './components/database-update.vue';
import result from './components/result.vue';

import {ref} from 'vue';
import {config} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();

const userName = ref('');
const passWord = ref('');

const setps = ref([
	{
		//数据库配置
		titleText: 'smanga正在进行初始化......',
		titlestate: 'default',
		btnLoading: true,
		btnDisabled: true,
	},
	{
		//新建用户
		titleText: '创建用户或是跳过',
		titlestate: 'default',
		btnLoading: false,
		btnDisabled: false,
	},
	{
		//初始化环境
		titleText: 'smanga正在进行数据库与环境升级......',
		titlestate: 'default',
		btnLoading: true,
		btnDisabled: true,
	},
	{
		//成功跳转
		titleText: 'smanga初始化成功!',
		titlestate: 'success',
		btnLoading: false,
		btnDisabled: false,
	},
]);

const active = ref(0);
const btnLoading = ref(true);
const btnDisabled = ref(false);

const isPhone = computed(() => {
	const screenType = config.screenType;
	return screenType === 'small' || screenType === 'mini';
});

function before() {
	if (active.value > 0) active.value--;
}

function next() {
	if (active.value < 3) active.value++;
}

function update_database_view(test: boolean) {
	setps.value[0].btnLoading = false;
	setps.value[0].btnDisabled = !test;

	setps.value[0].titleText = test
		? '数据库连接成功,您可以继续操作'
		: '数据库连接失败,请检查配置';
	setps.value[0].titlestate = test ? 'success' : 'fail';
}

function update_user_view(
	test: boolean,
	inputUserName: string,
	inputPassWord: string
) {
	setps.value[1].btnLoading = false;
	setps.value[1].btnDisabled = !test;

	setps.value[1].titleText = test ? '新建用户成功' : '新建用户失败';
	setps.value[1].titlestate = test ? 'success' : 'fail';

	if (test) {
		userName.value = inputUserName;
		passWord.value = inputPassWord;
	}
}

function update_system_view(
	test: boolean,
	targetStep: number,
	targetText: string
) {
	setps.value[targetStep].btnLoading = false;
	setps.value[targetStep].btnDisabled = !test;
	active.value = targetStep;
	setps.value[targetStep].titleText = targetText;
	setps.value[targetStep].titlestate = test ? 'success' : 'fail';
}

const __returned__ = { router, userName, passWord, setps, active, btnLoading, btnDisabled, isPhone, before, next, update_database_view, update_user_view, update_system_view, database, newUser, databaseUpdate, result }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})